import React, { useEffect, useState } from 'react';
import { LoadingSpinner } from 'legacy-packages/ft-cb';

function TagsInput({
  placeholder,
  value,
  onChange,
  isValidTag,
  dataTestId,
  tagErrors,
  setTagErrors,
}) {
  const [tags, setTags] = useState(Array.from(new Set(value)));
  const [tagValidations, setTagValidations] = useState(
    Array(tags.length).fill(true),
  );
  const [validating, setValidating] = useState(false);

  useEffect(() => {
    onChange(tags);
  }, [tags]);

  function handlePaste(e) {
    e.persist();
    setValidating(true);
    const pastedValues = (e.target.value + e.clipboardData.getData('Text'))
      .replace(/\s+/g, ',')
      .replace(';', ',')
      .split(',');
    const newTags = [];
    for (let i = 0; i < pastedValues.length - 1; i++) {
      let value = pastedValues[i].trim();
      if (value) {
        newTags.push(value);
      }
    }

    Promise.all(
      newTags.map((tag) => isValidTag(tag, tagErrors, setTagErrors)),
    ).then((response) => {
      setTagValidations([...tagValidations, ...response]);

      if (newTags.length > 0) {
        setTags([...tags, ...newTags]);
      }

      e.target.value = pastedValues[pastedValues.length - 1];
      setValidating(false);
    });
    e.preventDefault();
  }

  function handleKeyDown(e) {
    if (!['Enter', 'Tab', ' ', ';', ','].includes(e.key)) return;
    const value = e.target.value;
    if (!value.trim()) return;
    setValidating(true);
    e.persist();
    isValidTag(value, tagErrors, setTagErrors).then((valid) => {
      setTagValidations([...tagValidations, valid]);
      setTags([...tags, value]);
      e.target.value = '';
      setValidating(false);
    });
    e.preventDefault();
  }

  function removeTag(index) {
    setTagErrors(tagErrors.filter((validTag) => validTag !== tags[index]));
    setTags(tags.filter((el, i) => i !== index));
    setTagValidations(tagValidations.filter((el, i) => i !== index));
  }

  function tagPills() {
    return tags.map((tag, index) => (
      <div
        className={`h-9 leading-9 rounded-3xl ${
          tagValidations[index] !== true
            ? 'text-red-600 bg-red-100'
            : 'bg-blue-700 text-white'
        } px-3 text-base mt-2 mr-1`}
        key={index}
        data-test-id={`${dataTestId}-${index}-tag`}
      >
        <span data-test-id={`${dataTestId}-${index}-tag-label`}>{tag}</span>
        <button
          aria-label={`delete ${tag}`}
          className={`ml-2 rounded-3xl cursor-pointer ${
            tagValidations[index] !== true
              ? 'text-red-600 bg-red-100'
              : 'bg-blue-700 text-white'
          }`}
          onClick={() => removeTag(index)}
          data-test-id={`${dataTestId}-${index}-del`}
        >
          &times;
        </button>
      </div>
    ));
  }

  return (
    <div className="w-full border border-gray-400 rounded-3xl pl-2 pr-2 flex flex-row flex-wrap">
      {tagPills()}
      <div className="flex flex-row flex-1">
        {validating && (
          <div className="h-12.2 w-12.2 pt-2">
            <LoadingSpinner height={20} />
          </div>
        )}
        <input
          onPaste={handlePaste}
          onKeyDown={handleKeyDown}
          type="text"
          readOnly={validating}
          className={`h-12.2 flex-1 rounded-3xl`}
          placeholder={placeholder}
          data-test-id={`${dataTestId}-input`}
        />
      </div>
    </div>
  );
}

export default TagsInput;
